export default "__VITE_ASSET__C6S6sBsx__"